import { PostImage } from "../socialPost/interfaces/postImage";

const KEY = "wembii-pending-social-post-v1";

export function storePendingSocialPostImages(images: PostImage[]): void {
  sessionStorage.setItem(KEY, JSON.stringify({ images }));
}

/** Lee y elimina de sessionStorage para no reutilizar en otra visita. */
export function takePendingSocialPostImages(): PostImage[] | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    const parsed = JSON.parse(raw) as { images?: PostImage[] };
    if (!parsed.images?.length) return null;
    return parsed.images;
  } catch {
    return null;
  }
}
